export default [
  {title: '展示名称',dataIndex: 'displayName',scopedSlots: { customRender: 'displayName' }},
  {title: '门店全称',dataIndex: 'fullName'},
  {title: '门店地址',dataIndex: 'address'},
  {title: '门店编码',dataIndex: 'sn'},
  {title: '设备数量',dataIndex: 'bindDeviceAmount'},
  {title: '业务平台',dataIndex: 'appName'},
  {title: '经营者名称',dataIndex: 'operatorName'},
  {title: '经营者手机号',dataIndex: 'operatorPhone'},
  {title: '支付宝酒店信息',dataIndex: 'zfbHotelShowVO',scopedSlots: { customRender: 'zfbHotelShowVO' }},
  {title: '支付宝门店信息',dataIndex: 'zfbStoreShowVO',scopedSlots: { customRender: 'zfbStoreShowVO' }},
  {title: '操作',dataIndex: 'action', width: 180,scopedSlots: { customRender: 'action' }}
]

